module.exports = __webpack_public_path__ + "img/eventInout.ab1fb9ca.png";